import * as React from 'react';
import {useEffect} from 'react';
import {BodyScroll} from '../ScrollHandler';

interface ModalBackdropProps {
    onClick: () => void;
}

export const ModalBackdrop = ({onClick}: ModalBackdropProps) => {
    // Prevent body scroll on render
    useEffect(() => {
        BodyScroll(false);

        // Restore BodyScroll on unmount
        return () => {
            BodyScroll(true);
        };
    }, []);

    /**
     * Template
     */
    return (
        <div
            className="tw-fixed tw-overflow-y-hidden tw-z-[1040] tw-opacity-50 tw-top-0 tw-left-0 tw-w-[100vw] tw-h-[100vh] tw-bg-black"
            onClick={onClick}
        />
    );
};
